import React from "react";
import { dateToString } from "~/utils/formatter";

// Components
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import { useTranslation } from "react-i18next";
import { INVEST_LEVEL } from "~/constant/ApplyFormConstant";
import { COUNTRY_KOREAN } from "~/constant/ApplyManageConstant";

const ApplyDetailModal = ({ applyInfoModal, setApplyInfoModal, applyDetail }) => {
	const { t } = useTranslation();
	const answerMap = {
		SHORT(detailItem) {
			return detailItem.answer;
		},
		LONG(detailItem) {
			const brAnswer = detailItem.answer.replaceAll("\n", "<br />");
			return <div dangerouslySetInnerHTML={{ __html: brAnswer }} />;
		},
		CHOICE(detailItem) {
			return detailItem.answer;
		},
		ALTERNATIVE(detailItem) {
			return detailItem.answer;
		},
		AGREE(detailItem) {
			return (
				<>
					<div>
						{detailItem.description}
						<br />
						<br />
						{detailItem.answer ? "동의했습니다." : "동의하지않았습니다"}
					</div>
				</>
			);
		},
		TEXT(detailItem) { },
		FILE(detailItem) {
			return (
				<a href={detailItem.answer.path} target="_blank" rel="noreferrer">
					{detailItem.answer.name}
				</a>
			);
		},
		LINK(detailItem) {
			return (
				<a href={detailItem.answer} target="_blank" rel="noreferrer">
					{detailItem.answer}
				</a>
			);
		},
		ADDRESS(detailItem) {
			return detailItem.answer;
		},
		TAG(detailItem) {
			return detailItem.answer.map((tag, index) => (
				<div key={index}>
					{tag}
					{index !== detailItem.answer.length - 1 ? ", " : ""}
				</div>
			));
		},
		DATE(detailItem) {
			return dateToString(new Date(detailItem.answer), "yyyy-MM-dd");
		},
		CATEGORY(detailItem) {
			return detailItem.description;
		},
		SELECT(detailItem) {
			return detailItem.answer;
		},
		MULTISELECT(detailItem) {
			return detailItem.answer;
		},
	};

	const flattenedContents = applyDetail?.content
		?.reduce((acc, curr) => {
			if (curr.contents && curr.contents.length > 0) {
				acc.push(...curr.contents);
			}
			return acc;
		}, [])
		.sort(function (a, b) {
			return a.order - b.order;
		});


	// 기본정보는 startup 필드값으로 사용
	const basicInfo = (item) => {
		if (item.title === "기업명") return applyDetail?.startup?.name;
		if (item.title === "대표자 이름") return applyDetail?.startup?.ceo;
		if (item.title === "대표자 이메일") return applyDetail?.startup?.email;
		if (item.title === "설립연월")
			return dateToString(new Date(applyDetail?.startup?.establishedAt), "yyyy-MM-dd");
		if (item.title === "국가")
			return COUNTRY_KOREAN[applyDetail?.startup?.country] || applyDetail?.startup?.country;
		// return applyDetail?.startup?.country === "korea"
		// 	? t("pages.apply.ApplyList.ApplyListTable.republicOfKorea")
		// 	: t("pages.apply.ApplyList.ApplyListTable.foreign");
		if (item.title === "산업분야") return applyDetail?.startup?.industryField;
		if (item.title === "투자단계")
			return (
				INVEST_LEVEL.find((value) => value.value === applyDetail?.startup?.investLevel)
					?.label ?? "-"
			);
		else return item.answer ? answerMap[item.type](item) : "-";
	};

	return (
		<ModalTemplate
			modalState={applyInfoModal}
			setModalToggle={setApplyInfoModal}
			title={
				<>
					{t("pages.apply.ApplyList.ApplyListTable.applyContent")}
					<h3>{applyDetail?.startup?.name}</h3>
				</>
			}
			className="apply-list-modal"
		>
			<div className="modal-content">
				<div className="scroll-wrap">
					{flattenedContents?.length > 0 &&
						flattenedContents?.map((item, idx) => {
							const category = flattenedContents.filter(
								(item) => item.type === "CATEGORY"
							);
							const categoryIdx = category.findIndex(
								(value) => item.order === value.order
							);

							if (idx === 0)
								return (
									<section>
										{item?.type === "CATEGORY" && (
											<div className="header-wrap">
												<div className="category-title">
													{categoryIdx + 1}. {item.category}
												</div>
												<span className="apply-date">
													{t(
														"pages.apply.ApplyList.ApplyListTable.appliedDate"
													)}{" "}
													:{" "}
													{dateToString(
														applyDetail?.createdAt,
														"yyyy-MM-dd"
													)}
												</span>
											</div>
										)}
										<div className="c__form">
											{item?.type !== "TEXT" && item?.type !== "CATEGORY" && (
												<div className="f__group">
													<div className="f__label">{item.title}</div>
													<div className="f__control">
														{basicInfo(item)}
													</div>
												</div>
											)}
										</div>
									</section>
								);
							return (
								<section>
									{item?.type === "CATEGORY" && (
										<div className="category-title">
											{categoryIdx + 1}. {item.category}
										</div>
									)}
									<div className="c__form">
										{item?.type !== "TEXT" && item?.type !== "CATEGORY" && (
											<div className="f__group">
												<div className="f__label">{item.title}</div>
												<div className="f__control">{basicInfo(item)}</div>
											</div>
										)}
										<div className="character-length">
											{item.type === "LONG" &&
												`${item.answer && item.answer.length
													? item.answer.length
													: 0
												} / 1000`}
										</div>
									</div>
								</section>
							);
						})}
				</div>
			</div>
		</ModalTemplate>
	);
};

export default ApplyDetailModal;
